import React, { useEffect, useState } from "react";
import { getNodeServiceBaseUrl } from "../../../config/apiBase";
import { ErrorState, Skeleton, PageHeader, EmptyState } from "../../../shared-ui/States";
import "../../../shared-ui/crane-tokens.css";

const token = () => localStorage.getItem("zTaskAuthToken") || "";

export default function OpsDashboardPage() {
  const [kpis, setKpis] = useState(null);
  const [busy, setBusy] = useState(true);
  const [err, setErr] = useState("");

  const load = async () => {
    setBusy(true);
    setErr("");
    try {
      const res = await fetch(`${getNodeServiceBaseUrl()}/api/platform/ops-dashboard`, {
        headers: { Authorization: `Bearer ${token()}`, "X-Client": "web" },
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.message || `HTTP ${res.status}`);
      setKpis(body.data?.kpis || null);
    } catch (e) {
      setErr(e.message);
      setKpis(null);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const cards = kpis
    ? [
        { key: "open_work_orders", label: "Open work orders" },
        { key: "open_tasks", label: "Open tasks" },
        { key: "customers", label: "Customers" },
        { key: "invoices", label: "Invoices" },
        { key: "assets", label: "Assets" },
        { key: "inventory_items", label: "Inventory items" },
        { key: "low_stock_items", label: "Low stock", warn: true },
        { key: "open_quotes", label: "Open quotes" },
      ]
    : [];

  const allZero = kpis && cards.every((c) => Number(kpis[c.key] || 0) === 0);

  return (
    <div className="crane-page">
      <PageHeader
        crumbs={["Enterprise Platform", "Tenant Ops", "Global Operations"]}
        title="Operations dashboard"
        description="Live KPI counts from the database. Zeros mean no matching records — never fabricated."
        actions={
          <button type="button" className="crane-btn crane-btn--primary" onClick={load} disabled={busy}>
            Refresh
          </button>
        }
      />
      {busy && <Skeleton rows={5} height={48} />}
      {err && <ErrorState title="Dashboard unavailable" description={err} onRetry={load} />}
      {!busy && allZero && (
        <EmptyState title="No operational data yet" description="KPIs will populate as work orders, customers, invoices, and inventory records appear." />
      )}
      {!busy && kpis && !allZero && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
            gap: 10,
          }}
        >
          {cards.map((c) => (
            <div key={c.key} className="crane-card" style={{ padding: 12 }}>
              <div style={{ color: "var(--crane-on-surface-variant)", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                {c.label}
              </div>
              <div
                style={{
                  fontSize: 24,
                  fontWeight: 700,
                  color: c.warn && Number(kpis[c.key]) > 0 ? "var(--crane-error)" : "var(--crane-on-surface)",
                  marginTop: 8,
                }}
              >
                {Number(kpis[c.key] || 0)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
